const MatterSampleCardComponent = () => {
  return (
    <div className="mx-auto max-w-7xl p-6 md:p-8 lg:p-12">
      {/* Header Section */}
      <div className="mb-8 space-y-4">
        <div className="flex items-start justify-between gap-4">
          <div className="space-y-2">
            <h1 className="text-4xl font-bold tracking-tight text-gray-900">
              【案件】フルスタックエンジニア募集
            </h1>
            <p className="text-lg text-gray-600">
              大規模ECサイトのリニューアルプロジェクト
            </p>
          </div>
          <div className="badge badge-accent badge-lg">募集中</div>
        </div>

        {/* Quick Info Bar */}
        <div className="flex flex-wrap gap-4 text-sm text-gray-600">
          <div className="flex items-center gap-2">
            <svg
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <span>2025年4月開始</span>
          </div>
          <div className="flex items-center gap-2">
            <svg
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
            <span>2名募集</span>
          </div>
          <div className="flex items-center gap-2">
            <svg
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
            <span>基本リモート</span>
          </div>
        </div>
      </div>

      <div className="divider"></div>

      {/* Main Content Grid */}
      <div className="grid gap-6 lg:grid-cols-3">
        {/* Left Column - Main Details */}
        <div className="space-y-6 lg:col-span-2">
          {/* Project Overview */}
          <div className="card bg-base-100 shadow-xl">
            <div className="card-body">
              <h2 className="card-title flex items-center gap-2">
                <svg
                  className="h-5 w-5 text-primary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
                案件概要
              </h2>
              <div className="space-y-4">
                <div>
                  <h3 className="mb-2 font-semibold text-gray-900">
                    プロジェクト詳細
                  </h3>
                  <p className="leading-relaxed text-gray-600">
                    大手ECサイトのフルリニューアルプロジェクトです。既存システムからの移行を含め、
                    最新のマイクロサービスアーキテクチャを採用した新システムの構築を行います。
                    ユーザー体験の向上とパフォーマンス改善が主な目標となります。
                  </p>
                </div>

                <div>
                  <h3 className="mb-3 font-semibold text-gray-900">開発環境</h3>
                  <div className="flex flex-wrap gap-2">
                    <div className="badge badge-secondary">Next.js 15</div>
                    <div className="badge badge-secondary">TypeScript</div>
                    <div className="badge badge-secondary">React</div>
                    <div className="badge badge-secondary">Node.js</div>
                    <div className="badge badge-secondary">PostgreSQL</div>
                    <div className="badge badge-secondary">AWS</div>
                    <div className="badge badge-secondary">Docker</div>
                    <div className="badge badge-secondary">GitHub Actions</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Skills Required */}
          <div className="card bg-base-100 shadow-xl">
            <div className="card-body">
              <h2 className="card-title flex items-center gap-2">
                <svg
                  className="h-5 w-5 text-primary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                必須スキル
              </h2>
              <ul className="space-y-2">
                <li className="flex items-start gap-2">
                  <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />
                  <span className="text-gray-600">
                    React / Next.js を使用した開発経験 3年以上
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />
                  <span className="text-gray-600">
                    TypeScript での型定義・実装経験
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />
                  <span className="text-gray-600">
                    RESTful API の設計・実装経験
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />
                  <span className="text-gray-600">
                    Git を使用したチーム開発経験
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Nice to Have Skills */}
          <div className="card bg-base-100 shadow-xl">
            <div className="card-body">
              <h2 className="card-title flex items-center gap-2">
                <svg
                  className="h-5 w-5 text-primary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                  />
                </svg>
                尚可スキル
              </h2>
              <ul className="space-y-2">
                <li className="flex items-start gap-2">
                  <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-gray-400" />
                  <span className="text-gray-600">
                    AWS (EC2, S3, Lambda) の運用経験
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-gray-400" />
                  <span className="text-gray-600">
                    マイクロサービスアーキテクチャの設計経験
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-gray-400" />
                  <span className="text-gray-600">
                    CI/CD パイプラインの構築経験
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-gray-400" />
                  <span className="text-gray-600">アジャイル開発の経験</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Right Column - Conditions */}
        <div className="space-y-6">
          {/* Compensation */}
          <div className="card bg-primary/10 border-primary/20 shadow-xl">
            <div className="card-body">
              <h2 className="card-title text-primary flex items-center gap-2">
                <svg
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                報酬条件
              </h2>
              <div className="space-y-4">
                <div>
                  <div className="mb-1 text-sm text-gray-600">月額単価</div>
                  <div className="text-2xl font-bold text-gray-900">
                    ¥750,000
                  </div>
                  <div className="text-sm text-gray-600">
                    スキル見合い（目安: 70〜80万円）
                  </div>
                </div>
                <div className="divider"></div>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-600">精算幅</span>
                    <span className="font-medium text-gray-900">
                      140〜180時間
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">支払いサイト</span>
                    <span className="font-medium text-gray-900">30日</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Work Conditions */}
          <div className="card bg-base-100 shadow-xl">
            <div className="card-body">
              <h2 className="card-title flex items-center gap-2">
                <svg
                  className="h-5 w-5 text-primary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                勤務条件
              </h2>
              <div className="space-y-3 text-sm">
                <div className="flex items-start gap-3">
                  <svg
                    className="mt-0.5 h-4 w-4 shrink-0 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                  <div>
                    <div className="font-medium text-gray-900">勤務形態</div>
                    <div className="text-gray-600">
                      基本リモート（月1回出社）
                    </div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <svg
                    className="mt-0.5 h-4 w-4 shrink-0 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <div>
                    <div className="font-medium text-gray-900">勤務時間</div>
                    <div className="text-gray-600">
                      10:00 〜 19:00（休憩1時間）
                    </div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <svg
                    className="mt-0.5 h-4 w-4 shrink-0 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                  <div>
                    <div className="font-medium text-gray-900">最寄駅</div>
                    <div className="text-gray-600">渋谷駅 徒歩5分</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <svg
                    className="mt-0.5 h-4 w-4 shrink-0 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                  </svg>
                  <div>
                    <div className="font-medium text-gray-900">開始時期</div>
                    <div className="text-gray-600">2025年4月〜（応相談）</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Interview Process */}
          <div className="card bg-base-100 shadow-xl">
            <div className="card-body">
              <h2 className="card-title flex items-center gap-2">
                <svg
                  className="h-5 w-5 text-primary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
                面談について
              </h2>
              <div className="space-y-3 text-sm">
                <div>
                  <div className="mb-1 font-medium text-gray-900">面談方法</div>
                  <div className="text-gray-600">オンライン（Zoom）</div>
                </div>
                <div>
                  <div className="mb-1 font-medium text-gray-900">面談回数</div>
                  <div className="text-gray-600">1〜2回</div>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Info */}
          <div className="card bg-base-100 shadow-xl">
            <div className="card-body">
              <h2 className="card-title flex items-center gap-2">
                <svg
                  className="h-5 w-5 text-primary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                その他
              </h2>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-600">外国籍</span>
                  <div className="badge badge-accent badge-outline">可</div>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">地方在住</span>
                  <div className="badge badge-accent badge-outline">可</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Notes */}
      <div className="card bg-gray-50 mt-6">
        <div className="card-body">
          <h3 className="mb-2 font-semibold text-gray-900">備考</h3>
          <p className="text-sm leading-relaxed text-gray-600">
            本案件は長期案件となる予定です。チームは10名程度で、アジャイル開発を採用しています。
            週次でのスプリントレビューがあり、積極的にコミュニケーションを取れる方を歓迎します。
            リモートワーク中心ですが、チームビルディングのため月1回程度の出社をお願いしています。
          </p>
        </div>
      </div>

      {/* CTA Section */}
      <div className="mt-8 rounded-lg bg-primary p-6 text-center text-primary-content">
        <h2 className="mb-2 text-2xl font-bold">
          ご興味のある方はお気軽にご連絡ください
        </h2>
        <p className="mb-4 opacity-90">
          詳細な案件情報や、その他のご質問についてもお答えいたします
        </p>
        <div className="text-sm opacity-80">
          お問い合わせ: recruit@example.com
        </div>
      </div>
    </div>
  );
};

export default MatterSampleCardComponent;
